import { ApiResponse } from '../schemas/apiResponseSchema';
import apiClient from '../clients/apiClient';
import { Schemas } from '../types/api-types';

type FinancialDateResponse = Schemas['FinancialDateResponse'];

export async function fetchCurrentFinancialDate(): Promise<FinancialDateResponse> {
    try {
        const response: ApiResponse<FinancialDateResponse> = (await apiClient.get('/financial_date/current')).data;
        return response.data;
    } catch (error: any) {
        throw error;
    }

}